import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';


import styles from './Tooltip.scss';

function Tooltip({children, contents, id, isActive}) {

    if (!isActive) {

        return children;
    }

    return (
        <>
            <div
                data-for={id}
                data-tip={'tooltip'}
            >
                {children}
            </div>
            <ReactTooltip
                className={styles.tooltip}
                id={id}
                effect={'solid'}
                clickable={true}
            >
                {contents}
            </ReactTooltip>
        </>
    );
}


Tooltip.propTypes = {
    children: PropTypes.any.isRequired,
    contents: PropTypes.any,
    id: PropTypes.string.isRequired,
    isActive: PropTypes.bool
};

Tooltip.defaultProps = {
    contents: 'tooltip content',
    isActive: true
};


export default Tooltip;
